import { useState } from "react";
import React from "react";
import { Channel, Program, useEpg } from "planby";
import { theme } from "./helpers/theme";
let fecha = new Date();

let dia = [
  "00",
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
];

let mes = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
];

let fechaInicio =
  dia[fecha.getDate()] +
  "/" +
  mes[fecha.getMonth()] +
  "/" +
  fecha.getFullYear() +
  " " +
  fecha.toLocaleTimeString();

let fechaint = new Date();
let fechainte = new Date(fechaint);
let fechaFin =
  dia[fechainte.getDate()] +
  "/" +
  mes[fechainte.getMonth()] +
  "/" +
  fechainte.getFullYear() +
  " " +
  "23:59:59";

const date = new Date();

const fechaInicial = convertDateInitial();
const fechaFinal = convertDateFinal();

function convertDateInitial() {
  // Parse the input date string
  const inputDate = new Date();

  // Format the output date string
  const outputDateStr =
    (inputDate.getFullYear() + "-" + mes[inputDate.getMonth()])
      .toString()
      .padStart(2, "0") +
    "-" +
    inputDate.getDate().toString().padStart(2, "0") +
    "T" +
    (inputDate.getHours() - 2).toString().padStart(2, "0") +
    ":" +
    inputDate.getMinutes().toString().padStart(2, "0") +
    ":" +
    inputDate.getSeconds().toString().padStart(2, "0");

  return outputDateStr;
}

function convertDateFinal() {
  // Parse the input date string
  const inputDate = new Date();

  // Format the output date string
  const outputDateStr =
    (inputDate.getFullYear() + "-" + mes[inputDate.getMonth()])
      .toString()
      .padStart(2, "0") +
    "-" +
    inputDate.getDate().toString().padStart(2, "0") +
    "T24:00:00";

  return outputDateStr;
}

export function useApp() {
  const [canales, setCanales] = useState<any>([]);
  const [channels, setChannels] = React.useState<Channel[]>([]);
  const [epg, setEpg] = React.useState<Program[]>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const channelsData = React.useMemo(() => channels, [channels]);
  const epgData = React.useMemo(() => epg, [epg]);

  const { getEpgProps, getLayoutProps } = useEpg({
    channels: channelsData,
    epg: epgData,
    dayWidth: 7200,
    sidebarWidth: 100,
    itemHeight: 100,
    isSidebar: true,
    isTimeline: true,
    isLine: true,
    startDate: fechaInicial,
    endDate: fechaFinal,
    isBaseTimeFormat: true,
    theme,
  });

  const handleFetchResources = React.useCallback(async () => {
    if (
      sessionStorage.channels_parrilla != undefined &&
      sessionStorage.programs_parrilla != undefined
    ) {
      var canales = JSON.parse(sessionStorage.channels_parrilla);
      var programas = JSON.parse(sessionStorage.programs_parrilla);

      setEpg(programas as Program[]);
      setChannels(canales as Channel[]);
    }
  }, []);

  React.useEffect(() => {
    handleFetchResources();
  }, [handleFetchResources]);

  return { getEpgProps, getLayoutProps, isLoading };
}
